import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import InfoSections from "./components/InfoSections";
import ArticleCardsSection from "./components/ArticleCardsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";

const SITE_URL = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://mulebuy.asia';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <InfoSections />
        <ArticleCardsSection />
        <FAQSection />
        <CTASection />
      </main>
      <FooterSection />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Best Mulebuy Spreadsheet 2026 | Trusted Sellers & Latest Finds",
            "description": "Explore the latest Mulebuy Spreadsheet with trusted sellers, QC guides, shipping tips, verified products, and updated finds for sneakers, clothing, bags, and more.",
            "url": SITE_URL,
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": SITE_URL,
                },
              ],
            },
            "isPartOf": {
              "@type": "WebSite",
              "name": "Mulebuy Spreadsheet",
              "url": SITE_URL,
            },
          }),
        }}
      />
    </div>
  );
}